import type { SVGProps } from 'react';

type Name = 'home' | 'calendar' | 'cart' | 'kitchen' | 'users' | 'recipes' | 'spark' | 'check' | 'clock' | 'camera' | 'plus' | 'menu' | 'x' | 'arrow' | 'store' | 'leaf' | 'budget';

const paths: Record<Name, string[]> = {
  home: ['M3 11.5 12 4l9 7.5', 'M5 10.5V20h14v-9.5', 'M9 20v-6h6v6'],
  calendar: ['M5 3v3M19 3v3M4 8h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z'],
  cart: ['M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.6a2 2 0 0 0 2-1.6L20 7H6', 'M10 20h.01M17 20h.01'],
  kitchen: ['M4 5h16v15H4z', 'M4 10h16', 'M9 10v10', 'M7 7h.01M12 7h5'],
  users: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M22 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
  recipes: ['M4 5.5A2.5 2.5 0 0 1 6.5 3H11v17H6.5A2.5 2.5 0 0 0 4 22Z', 'M20 5.5A2.5 2.5 0 0 0 17.5 3H13v17h4.5A2.5 2.5 0 0 1 20 22Z'],
  spark: ['m12 3 1.3 4.2L17.5 8.5l-4.2 1.3L12 14l-1.3-4.2-4.2-1.3 4.2-1.3Z', 'm18 15 .8 2.2L21 18l-2.2.8L18 21l-.8-2.2L15 18l2.2-.8Z'],
  check: ['m5 12 4 4L19 6'],
  clock: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z', 'M12 6v6l4 2'],
  camera: ['M14.5 4 16 6h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l1.5-2Z', 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z'],
  plus: ['M12 5v14M5 12h14'],
  menu: ['M4 7h16M4 12h16M4 17h16'],
  x: ['M6 6l12 12M18 6 6 18'],
  arrow: ['M5 12h14M13 6l6 6-6 6'],
  store: ['M4 10v10h16V10', 'M3 10l2-6h14l2 6', 'M8 20v-6h8v6'],
  leaf: ['M20 4C12 4 6 8 6 14c0 3 2 6 6 6 7 0 8-9 8-16Z', 'M5 21c3-7 7-10 13-14'],
  budget: ['M12 2v20M17 6.5c0-2-2-3.5-5-3.5s-5 1.5-5 3.5 2 3.5 5 3.5 5 1.5 5 3.5S15 17 12 17s-5-1.5-5-3.5'],
};

export default function Icon({ name, ...props }: SVGProps<SVGSVGElement> & { name: Name }) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>{paths[name].map((d, i) => <path d={d} key={i} />)}</svg>;
}